<div class="flex flex-col gap-6 md:gap-8 pin-container px-10 pin-gradient-background">
  <div class="header-container container">
    <pin-new-header type="public" customClass="bg-transparent!" class="flex flex-row justify-baseline items-center"></pin-new-header>
  </div>
  <div class="container">
    <div class="flex flex-col md:flex-row justify-center items-start gap-12 mt-8" role="main">
      <div class="flex flex-col gap-6 w-full md:w-1/2">
        <div class="flex flex-col gap-2">
          <h1 class="dcp-h1 white-color">
            @switch (errorCode) {
              @case (statusCodeEnum.NOT_FOUND) {
                <span>Oops!</span>
              }
              @case (statusCodeEnum.SERVICE_UNAVAILABLE) {
                <span>Sorry, we are down for maintenance...</span>
              }
              @default {
                <span>Try again…</span>
              }
            }
          </h1>

          <p class="dcp-body white-color w-full md:w-3/4">
            @switch (errorCode) {
              @case (statusCodeEnum.NOT_FOUND) {
                The page you tried to reach no longer exists.
              }
              @case (statusCodeEnum.SERVICE_UNAVAILABLE) {
                Please try again later or contact your institution for further assistance. Thank you for your patience.
              }
              @default {
                An error has occurred. Please try your action again, or contact your financial institution for assistance.
              }
            }
          </p>
        </div>

        @if (errorCode && errorCode !== statusCodeEnum.SERVICE_UNAVAILABLE) {
          <p class=" dcp-body-bold white-color">
            <span>Error Code: {{ errorCode }}</span>
          </p>
        }

        <div class="flex flex-col gap-6 error-page-content w-full md:w-3/4">
          <div class="flex flex-col md:flex-row gap-6">
            @if (errorCode !== statusCodeEnum.NOT_FOUND && errorCode !== statusCodeEnum.SERVICE_UNAVAILABLE && errorMessageList.length !== 0) {
              <div class="w-full md:w-1/3">
                <pin-button buttonType="button"
                            buttonStyle="filled"
                            customClass="w-full white-button"
                            buttonId="show-hide-details-button" (buttonClick)="showConsoleDetails()">
                  {{ displayCard ? 'Hide details' : 'Show details' }}
                </pin-button>
              </div>
              <div class="w-full md:w-2/3">
                <pin-button buttonType="button"
                            buttonStyle="filled"
                            customClass="w-full white-button"
                            (buttonClick)="redirectToMainPage()">
                  Take me back
                </pin-button>
              </div>
            } @else if (errorCode === statusCodeEnum.SERVICE_UNAVAILABLE) {
              <div>
                <pin-button buttonType="button" buttonStyle="filled" customClass="white-button"
                            (buttonClick)="redirectToMainPage()">
                  TRY AGAIN
                </pin-button>
              </div>
            } @else {
              <div>
                <pin-button buttonType="button" buttonStyle="filled" customClass="white-button"
                            (buttonClick)="redirectToMainPage()">
                  TAKE ME BACK
                </pin-button>
              </div>
            }
          </div>
          @if (displayCard) {
            <div class="flex flex-col gap-6">
              <pin-card customClass="fill-height h-75! p-2! overflow-auto">
                <pin-card-content>
                  <div class="flex flex-col">
                    <span><b>user agent</b>: {{ userAgent }}</span>
                    <span><b>back-end connection</b>: {{ backEndConnection }}</span>
                    <span><b>browser errors</b>:
                      @for (errorMessage of errorMessageList; track errorMessage) {
                        {{ errorMessage }}<br>
                      }
                  </span>
                  </div>
                </pin-card-content>
              </pin-card>
            </div>
            <div class="flex flex-col gap-4 items-center">
              <pin-button buttonType="button" buttonStyle="filled" customClass="white-button" class="w-full"
                          (buttonClick)="copyDisplayedInformation()">
                Copy report
              </pin-button>
              @if (showTooltip) {
                <div role="tooltip" class="tooltip-wrapper">
                  <span class="account-summary-tooltip copy-report-tooltip">report copied!</span>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div>
        @switch (errorCode) {
          @case (statusCodeEnum.SERVICE_UNAVAILABLE) {
            <img src="../../../../assets/img/maintenance.png" alt="Illustration of broken laptop.">
          }
          @default () {
            <img src="../../../../assets/img/error.png" alt="Illustration of laptop with dead-end barrier.">
          }
        }
      </div>
    </div>
  </div>
  <div class="footer--main">
    <pin-footer type="public" customClass="bg-transparent! white-color"></pin-footer>
  </div>
</div>

@if (isLoading) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
